<template>
  <!-- eslint-disable vue/attribute-hyphenation -->
  <OptionalValidationWrapper
    :errorStyleExceptions="errorStyleExceptions"
    :handleError="handleError"
    :label="label"
    :name="name"
    :tooltip="tooltip"
  >
    <input
      :id="id"
      ref="input"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :class="{
        [$style.input]: true,
        [$style.inputInline]: inline,
        [$style.invalid]: handleError(),
        [inputClass] : inputClass,
      }"
      :data-lpignore="dataLpignore"
      :data-vv-scope="scope"
      :disabled="disabled"
      :max="max"
      :maxlength="maxlength"
      :min="min"
      :name="name"
      :placeholder="placeholder"
      :readonly="readonly"
      :required="required"
      :type="type"
      :value="value"
      @blur="$emit('blur', $event.currentTarget.value)"
      @change="valueChange"
      @focus="valueChange"
      @input="valueChange"
      @keydown.enter="$emit('enter', $event.currentTarget.value)"
    >
  </OptionalValidationWrapper>
</template>
<script>
import OptionalValidationMixin from 'components/FormValidation/mixins/OptionalValidationMixin';
import OptionalValidationWrapper from 'components/FormValidation/OptionalValidationWrapper.vue';
import TooltipPropMixin from 'components/FormValidation/mixins/TooltipPropMixin';

export default {
  name: 'Input',

  components: {
    OptionalValidationWrapper,
  },

  mixins: [
    OptionalValidationMixin,
    TooltipPropMixin,
  ],

  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
  },

  watch: {
    autofocus(value) {
      if (value) {
        this.$refs.input.focus();
      }
    },
  },

  mounted() {
    // Without this mounted method, autofocus only happens once when a modal
    // is opened. If you close and reopen the same modal, the input is not focused
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  },
};
</script>
<style scoped module>
@import "./css/FormValidationFields.css";
</style>
